import TextQuestion from './TextQuestion';
export default TextQuestion;